"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _reactDom = require("react-dom");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _UIScrollOverhang = _interopRequireDefault(require("./UIScrollOverhang"));

var _componentProp = require("../utils/propTypes/componentProp");

var _refObject = _interopRequireDefault(require("../utils/propTypes/refObject"));

var _Styles = require("../utils/Styles");

var isHorizontal = function isHorizontal(direction) {
  return direction === 'horizontal' || direction === 'both';
};

var isVertical = function isVertical(direction) {
  return direction === 'vertical' || direction === 'both';
};

var DefaultScrollContainer = _styledComponents.default.div.withConfig({
  displayName: "UIScrollContainer__DefaultScrollContainer",
  componentId: "sc-1dett08-0"
})(["height:100%;width:100%;max-height:", ";max-width:", ";overflow-x:", ";overflow-y:", ";position:relative;"], function (props) {
  return (0, _Styles.toPx)(props.maxHeight);
}, function (props) {
  return (0, _Styles.toPx)(props.maxWidth);
}, function (props) {
  return isHorizontal(props.scrollDirection) ? 'auto' : 'hidden';
}, function (props) {
  return isVertical(props.scrollDirection) ? 'auto' : 'hidden';
});

DefaultScrollContainer.propTypes = {
  children: _propTypes.default.node,
  maxHeight: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
  maxWidth: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
  scrollDirection: _propTypes.default.oneOf(['horizontal', 'vertical', 'both', 'none']).isRequired
};
DefaultScrollContainer.defaultProps = {
  scrollDirection: 'both'
};

var UIScrollContainer = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(UIScrollContainer, _React$Component);

  function UIScrollContainer() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, UIScrollContainer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(UIScrollContainer)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.refCallback = function (ref) {
      var _this$props = _this.props,
          scrollElementRef = _this$props.scrollElementRef,
          connectDragSource = _this$props.connectDragSource,
          connectDropTarget = _this$props.connectDropTarget;
      if (!(scrollElementRef || connectDragSource || connectDropTarget)) return;
      var el = (0, _reactDom.findDOMNode)(ref);

      if (scrollElementRef) {
        scrollElementRef.current = el;
      }

      if (connectDragSource) connectDragSource(el);
      if (connectDropTarget) connectDropTarget(el);
    };

    return _this;
  }

  (0, _createClass2.default)(UIScrollContainer, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          children = _this$props2.children,
          maxHeight = _this$props2.maxHeight,
          maxWidth = _this$props2.maxWidth,
          ScrollContainer = _this$props2.ScrollContainer,
          scrollDirection = _this$props2.scrollDirection,
          __scrollElementRef = _this$props2.scrollElementRef,
          rest = (0, _objectWithoutProperties2.default)(_this$props2, ["children", "maxHeight", "maxWidth", "ScrollContainer", "scrollDirection", "scrollElementRef"]);
      return _react.default.createElement(_UIScrollOverhang.default, rest, _react.default.createElement(ScrollContainer, {
        maxHeight: maxHeight,
        maxWidth: maxWidth,
        ref: this.refCallback,
        scrollDirection: scrollDirection
      }, children));
    }
  }]);
  return UIScrollContainer;
}(_react.default.Component);

UIScrollContainer.propTypes = Object.assign({}, _UIScrollOverhang.default.propTypes, {}, DefaultScrollContainer.propTypes, {
  ScrollContainer: (0, _componentProp.getComponentPropType)(DefaultScrollContainer),
  scrollElementRef: _refObject.default,
  connectDropTarget: _propTypes.default.func,
  connectDragSource: _propTypes.default.func
});
UIScrollContainer.defaultProps = Object.assign({}, _UIScrollOverhang.default.defaultProps, {}, DefaultScrollContainer.defaultProps, {
  ScrollContainer: DefaultScrollContainer
});
UIScrollContainer.displayName = 'UIScrollContainer';
var _default = UIScrollContainer;
exports.default = _default;
module.exports = exports.default;